import { Grid } from '@mui/material';

import { disabledFutureDate } from '../../../../../../../helpers';
import { FormAutocompleteField, FormDateField } from '../../../../../../common';
import { HEARING_DIFFICULTY_OPTIONS, VISION_DIFFICULTY_OPTIONS } from '../constants';

import type { MedicalInfoFieldsProps } from './types';

export default function MedicalSensoryFields({
  formik,
  disabled,
  saveFieldOnBlur,
  areScreeningDatesRequired,
}: MedicalInfoFieldsProps) {
  return (
    <>
      <Grid item xs={12} sm={6}>
        <FormAutocompleteField
          disabled={disabled}
          formik={formik}
          label="Hearing difficulty"
          name="hearing_difficulty"
          onChange={saveFieldOnBlur}
          options={HEARING_DIFFICULTY_OPTIONS}
          placeholder="Select hearing difficulty"
          required
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <FormDateField
          allowClear
          disabled={disabled}
          disabledDate={disabledFutureDate}
          formik={formik}
          label="Hearing screening date"
          name="hearing_screening_date"
          onChange={saveFieldOnBlur}
          placeholder="Select screening date"
          required={areScreeningDatesRequired}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <FormAutocompleteField
          disabled={disabled}
          formik={formik}
          label="Vision difficulties"
          name="vision_difficulty"
          onChange={saveFieldOnBlur}
          options={VISION_DIFFICULTY_OPTIONS}
          placeholder="Select vision difficulties"
          required
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <FormDateField
          allowClear
          disabled={disabled}
          disabledDate={disabledFutureDate}
          formik={formik}
          label="Vision screening date"
          name="vision_screening_date"
          onChange={saveFieldOnBlur}
          placeholder="Select screening date"
          required={areScreeningDatesRequired}
        />
      </Grid>
    </>
  );
}
